import { render, staticRenderFns } from "./Boyd.vue?vue&type=template&id=498e7b59"
import script from "./Boyd.vue?vue&type=script&lang=js"
export * from "./Boyd.vue?vue&type=script&lang=js"
import style0 from "../css/nabi-boyd.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports